import { OrganizationIdentifierScheme } from '@debbie/common/dist/customers/types.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../../utils/errors.js';
import Input from '../../Input.js';
import Select from '../../Select.js';
import UserInfoEntity from './UserInfoEntity.js';
const UserRegistryIdentifier = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const [registryIdentifierValue, setRegistryIdentifierValue] = useState(details.registryIdentifier?.value);
    const [registryIdentifierScheme, setRegistryIdentifierScheme] = useState(details.registryIdentifier?.scheme || OrganizationIdentifierScheme.GLN);
    const patchRegistryIdentifier = useMutation((registryIdentifier) => props.patchUser({ registryIdentifier }), {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.party);
        },
    });
    return (React.createElement(React.Fragment, null, React.createElement(UserInfoEntity, { title: lang.debtorInfo.registryIdentifier, value: details.registryIdentifier, renderEditor: (selectedValue) => (React.createElement(RegistryIdentifierWrapper, null,
            React.createElement(Select, { value: registryIdentifierScheme, onChange: (e) => {
                    setRegistryIdentifierScheme(e.target.value);
                }, style: { width: '150px' } }, Object.values(OrganizationIdentifierScheme).map((oId) => (React.createElement("option", { key: oId, value: oId }, oId)))),
            React.createElement(Input, { style: { marginLeft: '10px', width: '300px' }, placeholder: lang.debtorInfo.registryIdentifier, value: registryIdentifierValue, button: {
                    value: lang.misc.save,
                    loading: patchRegistryIdentifier.isLoading,
                    onClick: () => {
                        selectedValue({
                            scheme: registryIdentifierScheme,
                            value: registryIdentifierValue,
                        });
                        patchRegistryIdentifier.mutate({
                            scheme: registryIdentifierScheme,
                            value: registryIdentifierValue,
                        });
                    },
                }, onChange: (e) => {
                    setRegistryIdentifierValue(e.target.value);
                } }))), renderValue: (registryIdentifier) => {
            return ((registryIdentifier &&
                registryIdentifier.scheme &&
                registryIdentifier.value && (React.createElement(React.Fragment, null, `${registryIdentifier.scheme}:${registryIdentifier.value}`))) || (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.registryIdentifier)));
        }, onChange: (val) => { }, removable: true })));
};
export default UserRegistryIdentifier;
const RegistryIdentifierWrapper = styled.div `
  display: inline-flex;
`;
//# sourceMappingURL=UserRegistryIdentifier.js.map